import {Button, MenuItem} from '@material-ui/core';
import * as I from 'immutable';
import React, {useState} from 'react';
import {useSelector} from 'react-redux';
import OutlinedSelect from 'Shared/components/OutlinedSelect';
import {Scope} from 'Shared/constants/Scope';
import {hasAccessToScopeByApplication} from 'Shared/utilities/applicationId';
import {Application} from 'Users/models/Application';
import {LineOfBusiness} from 'Users/models/LineOfBusiness';
import {isExternalBasicInformation} from 'Users/models/User/BasicInformation';
import {User} from 'Users/models/User/User';
import {
  isAgentUserType,
  isBeneficiaryUserType,
  isBosToolsUserType,
  isEnrollmentTrackingUserType,
  UserType,
  isMessagingUserType,
  isAppEntryUserType,
} from 'Users/models/User/UserType';
import {selectUserScopes} from 'Users/selectors/userProfileSelectors';
import './LineOfBusinessSelect.sass';

type LineOfBusinessSelectProps = {
  onSelectLineOfBusiness: (lineOfBusiness: LineOfBusiness) => void;
  user: User;
};

const LineOfBusinessSelect = (props: LineOfBusinessSelectProps) => {
  const [lineOfBusiness, setSelectedLineOfBusiness] = useState<LineOfBusiness | ''>('');
  const {user, onSelectLineOfBusiness} = props;
  const userTypes: I.List<UserType> = user.userTypes;
  const userTypeValues = userTypes.map(ut => ut.value);

  const scopes = useSelector(selectUserScopes);

  return (
    <div className="line-of-business-entry">
      <OutlinedSelect
        label="Line of Business"
        className="line-of-business-entry__select"
        value={lineOfBusiness}
        onChange={e => setSelectedLineOfBusiness(parseInt(e.target.value, 10) as LineOfBusiness)}
      >
        {/* <MenuItem
          value={LineOfBusiness.Agent}
          disabled={
            userTypeValues.some(isAgentUserType) ||
            !hasAccessToScopeByApplication(scopes, Scope.AddUser, Application.Agent)
          }
        >
          Agent
        </MenuItem> */}
        {/* <MenuItem
          value={LineOfBusiness.EnrollmentTracking}
          disabled={
            userTypeValues.some(isEnrollmentTrackingUserType) ||
            !hasAccessToScopeByApplication(scopes, Scope.AddUser, Application.EnrollTrack)
          }
        >
          EnrollTrack
        </MenuItem> */}
        <MenuItem
          value={LineOfBusiness.Beneficiary}
          disabled={
            isExternalBasicInformation(user.basicInformation) ||
            userTypeValues.some(isBeneficiaryUserType) ||
            !hasAccessToScopeByApplication(scopes, Scope.AddUser, Application.Beneficiary)
          }
        >
          Beneficiary
        </MenuItem>
        <MenuItem
          value={LineOfBusiness.BOSTools}
          disabled={
            isExternalBasicInformation(user.basicInformation) ||
            userTypeValues.some(isBosToolsUserType) ||
            !hasAccessToScopeByApplication(scopes, Scope.AddUser, Application.BOSTools)
          }
        >
          BOS Tools
        </MenuItem>
        {/* <MenuItem
          value={LineOfBusiness.Messaging}
          disabled={
            isExternalBasicInformation(user.basicInformation) ||
            userTypeValues.some(isMessagingUserType) ||
            !hasAccessToScopeByApplication(scopes, Scope.AddUser, Application.Messaging)
          }
        >
          Messaging
        </MenuItem> */}
        <MenuItem
          value={LineOfBusiness.AppEntry}
          disabled={
            isExternalBasicInformation(user.basicInformation) ||
            userTypeValues.some(isAppEntryUserType) ||
            !hasAccessToScopeByApplication(scopes, Scope.AddUser, Application.AppEntry)
          }
        >
          App Entry
        </MenuItem>
      </OutlinedSelect>
      <Button
        className="line-of-business-entry__add-access-button"
        color="primary"
        variant="contained"
        disabled={lineOfBusiness === ''}
        onClick={() => {
          if (lineOfBusiness !== '') {
            onSelectLineOfBusiness(lineOfBusiness);
            setSelectedLineOfBusiness('');
          }
        }}
      >
        Add Access
      </Button>
    </div>
  );
};

export default LineOfBusinessSelect;
